(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class ContactFormExtras extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.honeypot = this.querySelector('input[name="website"]');
      this.areas = this.querySelectorAll('.contact-form-section__area');
      this.areasValue = this.querySelector('.contact-form-section__areas-value');
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.areas.forEach((cb) => cb.addEventListener('change', this.syncAreas.bind(this)));
      this.syncAreas();
      this.prefillFromQuery();
    }

    // Products priced "ASK" (price on request) have no Add to Cart button; the dealer
    // parts pages link here with the item in the query string
    // (?inq_title=&inq_sku=; inq_handle is still sent but no longer rendered). Seed the
    // Comment field so the inquiry says what it is about. Only when the field is empty,
    // so a validation re-render never clobbers what the visitor typed — and they can
    // freely edit or clear the seeded text.
    prefillFromQuery() {
      const body = this.querySelector('textarea[name="contact[body]"]');
      if (!body || body.value.trim() !== '') return;

      let params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return;
      }
      const clean = (v) => String(v || '').replace(/[\r\n\t]+/g, ' ').trim().slice(0, 200);
      const title = clean(params.get('inq_title'));
      const sku = clean(params.get('inq_sku'));
      if (!title && !sku) return;

      const lines = ['Product inquiry'];
      if (title) lines.push('Product: ' + title);
      if (sku) lines.push('Part No.: ' + sku);
      lines.push('---', 'Add your comment here...', '');
      body.value = lines.join('\n');
    }

    // Shopify's contact form rejects array fields (contact[...][]) as "invalid",
    // so collect the checked areas into one scalar, comma-separated value.
    syncAreas() {
      const checked = Array.from(this.areas)
        .filter((cb) => cb.checked)
        .map((cb) => cb.value);
      if (this.areasValue) this.areasValue.value = checked.join(', ');
    }

    handleSubmit(event) {
      // Honeypot: a real user never fills this. Silently drop the submission.
      if (this.honeypot && this.honeypot.value !== '') {
        event.preventDefault();
        return;
      }

      // "Area(s) of interest" is optional — just sync whatever is checked.
      this.syncAreas();
    }
  }

  if (!customElements.get('contact-form-extras')) {
    customElements.define('contact-form-extras', ContactFormExtras);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealer-locator"] && !Shopify.designMode) return;
  try {
    
  class DealerLocator extends HTMLElement {
    constructor() {
      super();
      this.dealers = [];
      this.markers = {};
      this.map = null;
    }

    connectedCallback() {
      this.cards = this.querySelector('[data-dl-cards]');
      this.countEl = this.querySelector('[data-dl-count]');
      this.select = this.querySelector('[data-dl-country]');
      this.input = this.querySelector('[data-dl-query]');
      this.mapEl = this.querySelector('[data-dl-map]');
      this.markerColor = this.dataset.markerColor || '#16578E';

      const go = this.querySelector('[data-dl-go]');
      if (go) go.addEventListener('click', () => this.apply());
      if (this.select) this.select.addEventListener('change', () => this.apply());
      if (this.input) {
        this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') this.apply(); });
        this.input.addEventListener('input', () => { if (!this.input.value.trim()) this.apply(); });
      }

      this.loadLeaflet().then(() => this.init()).catch(() => this.renderError());
    }

    loadLeaflet() {
      return new Promise((resolve, reject) => {
        if (window.L) { resolve(); return; }
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
        document.head.appendChild(css);
        const js = document.createElement('script');
        js.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
        js.onload = resolve;
        js.onerror = reject;
        document.head.appendChild(js);
      });
    }

    init() {
      try {
        const dataEl = this.querySelector('[data-dealers]');
        this.dealers = JSON.parse(dataEl.textContent);
      } catch (e) { this.renderError(); return; }

      const L = window.L;
      this.map = L.map(this.mapEl, { scrollWheelZoom: false }).setView([50, 9], 4);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18, attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);

      const icon = L.divIcon({
        className: 'dealer-locator__pin',
        html: '<svg width="26" height="34" viewBox="0 0 26 34" xmlns="http://www.w3.org/2000/svg"><path d="M13 0C5.8 0 0 5.8 0 13c0 9.2 13 21 13 21s13-11.8 13-21C26 5.8 20.2 0 13 0z" fill="' + this.markerColor + '"/><circle cx="13" cy="13" r="5" fill="#fff"/></svg>',
        iconSize: [26, 34], iconAnchor: [13, 34], popupAnchor: [0, -30]
      });

      this.group = L.featureGroup().addTo(this.map);
      this.dealers.forEach((d) => {
        if (typeof d.lat !== 'number' || typeof d.lng !== 'number') return;
        const m = L.marker([d.lat, d.lng], { icon }).addTo(this.group);
        const contact = d.url
          ? '<a href="' + this.esc(d.url) + '" target="_blank" rel="noopener">Website</a>'
          : (d.tel ? 'Tel: ' + this.esc(d.tel) : '');
        m.bindPopup('<b>' + this.esc(d.name) + '</b><br>' + this.esc(d.city) + ', ' + this.esc(d.country) + '<br>' + contact);
        this.markers[d.id] = m;
      });
      if (this.group.getLayers().length) this.map.fitBounds(this.group.getBounds().pad(0.1));

      this.buildCountries();
      this.render(this.dealers);
    }

    buildCountries() {
      const counts = {};
      this.dealers.forEach((d) => { counts[d.country] = (counts[d.country] || 0) + 1; });
      const list = Object.keys(counts).sort();
      this.select.innerHTML =
        '<option value="">All countries (' + this.dealers.length + ')</option>' +
        list.map((c) => '<option value="' + this.esc(c) + '">' + this.esc(c) + ' (' + counts[c] + ')</option>').join('');
    }

    fullAddr(d) {
      return [d.address, ((d.postcode || '') + ' ' + (d.city || '')).trim(), d.country].filter(Boolean).join('<br>');
    }

    render(list) {
      this.cards.innerHTML = '';
      this.countEl.textContent = list.length + (list.length === 1 ? ' dealer' : ' dealers') + ' found';
      if (!list.length) {
        this.cards.innerHTML = '<div class="dealer-locator__empty">No dealers found. Try another country or search term.</div>';
        return;
      }
      list.forEach((d) => {
        const contact = d.url
          ? '<a class="dealer-locator__link" href="' + this.esc(d.url) + '" target="_blank" rel="noopener">Visit website &rarr;</a>'
          : (d.tel ? '<div class="dealer-locator__tel">Tel: ' + this.esc(d.tel) + '</div>' : '');
        const card = document.createElement('div');
        card.className = 'dealer-locator__card';
        card.dataset.id = d.id;
        card.innerHTML =
          '<span class="dealer-locator__badge">' + this.esc(d.country) + '</span>' +
          '<h3>' + this.esc(d.name) + '</h3>' +
          '<div class="dealer-locator__addr">' + this.fullAddr(d) + '</div>' +
          contact;
        card.addEventListener('click', () => {
          this.querySelectorAll('.dealer-locator__card').forEach((c) => c.classList.remove('is-active'));
          card.classList.add('is-active');
          const m = this.markers[d.id];
          if (m) { this.map.setView(m.getLatLng(), 13, { animate: true }); m.openPopup(); }
        });
        this.cards.appendChild(card);
      });
    }

    apply() {
      const c = this.select ? this.select.value : '';
      const q = this.input ? this.input.value.trim().toLowerCase() : '';
      const list = this.dealers.filter((d) =>
        (!c || d.country === c) &&
        (!q || (d.name + ' ' + d.address + ' ' + d.postcode + ' ' + d.city + ' ' + d.country).toLowerCase().indexOf(q) !== -1)
      );
      this.render(list);
      const pts = list.map((d) => this.markers[d.id]).filter(Boolean);
      Object.keys(this.markers).forEach((id) => {
        this.markers[id].setOpacity(list.find((d) => String(d.id) === id) ? 1 : 0.25);
      });
      if (pts.length && window.L) this.map.fitBounds(window.L.featureGroup(pts).getBounds().pad(0.2));
    }

    esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    }

    renderError() {
      if (this.countEl) this.countEl.textContent = 'Unable to load the dealer map. Please reload the page.';
    }
  }

  if (!customElements.get('dealer-locator')) {
    customElements.define('dealer-locator', DealerLocator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
